import React, { useEffect, useState } from "react";
import Button from "../button/Button";
import ButtonAction from "../button/ButtonAction";
import IGroupExplore from "./IGroupExplore";
import CHElement from "../../../model/CHElement";
import APIEndPoints from "../../../utils/APIEndPoints";
import Site from "../../../model/Site";
import ImgUtil from "../../../utils/ImgUtil";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../../globals";
import AppSections from "../../../utils/AppSections";
import AppSubSections from "../../../utils/AppSubSections";
import { Tooltip } from "react-tooltip";
import { useAppSelector } from "../../../redux/hooks";
import MyList from "../../../model/MyList";
import Collection from "../../../model/Collection";
import GroupingType from "../../../model/enums/GroupingType";

function GroupExplore({
  groupID,
  groupType,
  apiClient,
  onCloseDefault = () => {},
}: IGroupExplore) {
  // keep the information about the currently displayed group
  const [groupInfo, setGroupInfo] = useState<
    Site | MyList | Collection | undefined
  >(undefined);
  // keep the information about the assets in the group
  const [assetsInfo, setAssetsInfo] = useState<CHElement[]>([]);
  // get a reference to navigation component
  const navigate = useNavigate();

  const activeAssetID = useAppSelector(
    (state) => state.groupExplorerActiveAssetID.value,
  );

  useEffect(() => {
    const getAllData = async () => {
      // fetch group info
      let auxGroupInfo: Site | MyList | Collection | undefined;

      if (groupType === GroupingType.SITE) {
        auxGroupInfo = await apiClient.get<Site>({
          url: APIEndPoints.SITES.ONE(groupID),
        });
      } else if (groupType === GroupingType.COLLECTION) {
        auxGroupInfo = await apiClient.get<Collection>({
          url: APIEndPoints.COLLECTIONS.ONE(groupID),
        });
      } else {
        auxGroupInfo = await apiClient.get<MyList>({
          url: APIEndPoints.MY_LISTS.ONE(groupID),
        });
      }
 

      // cache information before saving it into State
      const auxAssetsInfo = [];

      // make sure we have valid group information
      if (
        auxGroupInfo &&
        auxGroupInfo.chelements &&
        Array.isArray(auxGroupInfo.chelements)
      ) {
        // TODO - optimization by including in the list of group's assets the ICON
        // this way we do not neet to call the API for each CHElement
        for (let i = 0; i < auxGroupInfo.chelements.length; i++) {
          const assetID = auxGroupInfo.chelements[i].id!;
          const assetInfo = await apiClient.get<CHElement>({
            url: APIEndPoints.CHELEMENTS.ONE(assetID),
          });
          // test if we have received a valid asset description
          if (assetInfo) {
            auxAssetsInfo.push(assetInfo);
          }
        }
      }
      setGroupInfo(auxGroupInfo);
      setAssetsInfo(auxAssetsInfo);
    };
    getAllData();
  }, [apiClient, groupID]);

  if (!groupInfo || assetsInfo.length === 0) {
    return null;
  }

  const groupingLabel =
    groupType === GroupingType.SITE
      ? "Site"
      : groupType === GroupingType.MY_LIST
        ? "List"
        : "Collection";

  return (
    <div className="grouping-explore-container">
      <div className="mb-3 text-xs text-white">Explore {groupingLabel}</div>
      {assetsInfo.map((a, index) => {
        const css = a.id === activeAssetID ? "selected" : "";
        return (
          <>
            <a
              data-tooltip-id={"element-" + index}
              data-tooltip-place="right"
              onClick={() => {
                navigate(
                  SETTINGS.get_path({
                    section: AppSections.CHELEMENTS,
                    id: a.id,
                    subsection: AppSubSections.VIEW,
                  }),
                );
              }}
            >
              <img
                src={
                  ImgUtil.display_icon(a.icon_path) ||
                  process.env.REACT_APP_PUBLIC_URL +
                    "/resources/images/no-image.png"
                }
                alt={groupingLabel + " icon"}
                className={css}
              />
            </a>
            <Tooltip id={"element-" + index}>{a.name}</Tooltip>
          </>
        );
      })}
      <Button
        purpose={ButtonAction.CANCEL}
        label={""}
        className="text-xs p-0 pl-2 pt-1 mt-3 ml-2"
        onClick={() => {
          onCloseDefault();
        }}
      />
    </div>
  );
}

export default GroupExplore;
